/* eslint-disable */
import requestRaw from "@/utils/requestRaw";
import { APICoreV2 } from "@/utils/servicesApi";

const BASE_URL = APICoreV2() + "/omni/auto-follow-up";

function post(path, data, options) {
  return requestRaw(Object.assign({
    url: BASE_URL + path,
    method: "POST",
    data: data
  }, options || {}));
}

export function listAutoFollowUp(data) {
  return post("/list", data);
}

export function statsAutoFollowUp(data) {
  return post("/stats", data);
}

export function storedAutoFollowUp(data) {
  return post("/stored", data);
}

export function detailAutoFollowUp(data) {
  return post("/detail", data);
}

export function detailAutoFollowUpSilent(data) {
  return post("/detail", data, { silent: true });
}

export function recipientListAutoFollowUp(data) {
  return post("/recipient-list", data);
}

export function stopRecipientAutoFollowUp(data) {
  return post("/recipient-stop", data);
}

export function eventsAutoFollowUp(data) {
  return post("/events", data);
}

export function activateAutoFollowUp(data) {
  return post("/activate", data);
}

export function pauseAutoFollowUp(data) {
  return post("/pause", data);
}

export function resumeAutoFollowUp(data) {
  return post("/resume", data);
}

export function cancelAutoFollowUp(data) {
  return post("/cancel", data);
}

export function retrySchedulingAutoFollowUp(data) {
  return post("/retry-scheduling", data);
}

export function licenseQuotaAutoFollowUp(data) {
  return post("/license-quota", data);
}

export function reconcileLicenseQuotaAutoFollowUp(data) {
  return post("/license-quota/reconcile", data);
}

export function resetLicenseQuotaAutoFollowUp(data) {
  return post("/license-quota/reset", data);
}

export function deleteAutoFollowUp(data) {
  return post("/delete", data);
}

export function templateStoredAutoFollowUp(data) {
  return post("/template-stored", data, { silent: true });
}

export function templateListAutoFollowUp(data) {
  return post("/template-list", data, { silent: true });
}

export function templateDetailAutoFollowUp(data) {
  return post("/template-detail", data, { silent: true });
}

export function templateDeleteAutoFollowUp(data) {
  return post("/template-delete", data, { silent: true });
}

export function templateUseAutoFollowUp(data) {
  return post("/template-use", data, { silent: true });
}



// WEBPACK FOOTER //
// ./src/api/autoFollowUp.js